<template>
  <Swiper
      v-if="products.length"
      :modules="[Navigation]"
      :breakpoints="props.narrow ? shortBreakpoints : carouselBreakpoints"
      :space-between="20"
      :navigation="true"
      :speed="500"
      :a11y="carouselTranslations"
  >
    <SwiperSlide
        v-for="product in products"
        :key="product.id"
    >
      <div class="w-full flex items-center justify-center">
        <OfferProductCard :product="product" :compare="compare"/>
      </div>
    </SwiperSlide>
  </Swiper>
</template>

<script setup>
import OfferProductCard from "../composables/OfferProductCard.vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from 'swiper/modules';
import {carouselTranslations, carouselBreakpoints, shortBreakpoints} from "../utils";

const props = defineProps({
  products: Array,
  breakpoints: Object,
  narrow: {
    default: false,
    type: Boolean,
  },
  compare: {
    default: true,
    type: Boolean,
  }
});
</script>